module.exports = __webpack_public_path__ + "img/xasc-top-banner.a09fdb98.gif";